var map = {
	"./favicon.ico": 2989,
	"./features-bg.png": 491,
	"./features-element.png": 8079,
	"./hero-image.png": 5664,
	"./listening-music.jpg": 7750,
	"./logo1100.png": 5895,
	"./logo128.png": 3118,
	"./music-peaceful.jpg": 2625,
	"./scroll-playlists.jpg": 4170,
	"./testimonial.jpg": 9428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;